<template>
  <div class="formulario px-0">
    <!-- <div class="row">
      <div class="col-12 col-lg-4">
        <div class="form-group">
          <label class="generalLabel" for="from">Desde</label>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="form-group">
          <label class="generalLabel" for="to">Hasta</label>
        </div>
      </div>
      <div class="col-12 col-lg-3">
        <div class="form-group">
          <label class="generalLabel" for="score">Puntuación</label>
        </div>
      </div>
    </div> -->
    <div class="row" v-for="(item, index) in size" :key="item">
      <div class="col-12 col-lg-4">
        <div class="form-group">
          <label class="generalLabel" for="from">Desde</label>
          <input type="number" placeholder="0" class="form-control generalInput typeNumber" id="from"
            v-model.trim="from[index]">
          <small class="form-text text-danger"
            v-if="index != 0 && parseInt(from[index]) <= parseInt(to[index - 1])">Debe
            ser mayor que el tramo anterior</small>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="form-group">
          <label class="generalLabel" for="to">Hasta</label>
          <input type="number" placeholder="0" class="form-control generalInput typeNumber" id="to"
            v-model.trim="to[index]">
          <small class="form-text text-danger" v-if="parseInt(to[index]) <= parseInt(from[index])">Debe
            ser mayor que el precio anterior</small>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="form-group">
          <label class="generalLabel" for="score">Puntuación</label>
          <div class="row m-0 d-flex justify-content-between">
            <input type="number" placeholder="0" class="form-control generalInput col-10 typeNumber" id="score"
              v-model.trim="score[index]">
            <a href="#" @click="addInputs(index)" v-if="index == from.length - 1" class="pt-1">
              <v-icon class="plusIcon p-0 col" name="hi-plus" scale="1.8" />
            </a>
          </div>
          <small class="form-text text-danger"
            v-if="index != 0 && parseInt(score[index]) >= parseInt(score[index - 1])">Debe
            ser menor que la puntuación anterior</small>
        </div>
      </div>
    </div>
    <div class="col-12 pr-0">
      <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
        <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
        <button class="btn btn-primary generalPrimaryButton" :disabled="(correctSections())"
          @click="sendRatings()">Guardar</button>
      </div>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import axios from 'axios';
import {
  required
} from '@vuelidate/validators'

export default {
  name: 'AddSections',
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      from: [0],
      to: [1],
      score: [100],
      size: 1,
      username: this.$cookies.get('username'),
    };
  },
  validations() {
    return {
      from: {
        $each: {
          required,
          isGrant(value) {
            console.log(value)
          }
        }
      },
    }
  },
  methods: {
    addInputs(index) {
      this.from.push(parseInt(this.to[index]) + 1)
      this.to.push(parseInt(this.from[index + 1]) + 1)
      this.score.push(parseInt(this.score[index]) - 10)
      this.size += 1
    },
    cleanSearch() {
      this.from = [0];
      this.to = [1];
      this.score = [100];
      this.size = 1;
    },
    correctSections() {
      let disabled = false
      for (let index = 0; index < this.size; index++) {
        // if (this.from[index] == '' || this.to[index] == '' || this.score[index] == '') {
        //   disabled = true
        // }
        if (this.from[index] >= this.to[index]) {
          disabled = true
        }
        if (index > 0) {
          if (this.from[index] <= this.to[index - 1]) {
            disabled = true
          }
          if (this.score[index] > this.score[index - 1]) {
            disabled = true
          }
        }
      }

      return disabled
    },
    sendRatings() {
      let list;
      let result = [];
      for (let index = 0; index < this.from.length; index++) {
        list =
        {
          "since": this.from[index],
          "until": this.to[index],
          "rating": this.score[index],
        }
        result.push(list);
      }

      let bodyToSend = {
        "productRatings":
          result
      }

      const config = {
        headers: {
          'X-User': this.username,
        }
      };
      axios.post('/application-product-rating', bodyToSend, config)
        .then(() => {
          // location.reload();
          this.$emit("refreshAddRegisterList");
        })
        .catch(() => {
        });
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.formulario {
  padding: 0 15px;
}

.typeNumber::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

.typeNumber {
  appearance: textfield;
}
</style>
